import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { i18n, setLocale, getLocale } from 'core/i18n';
import Tools from 'core/tools';

import Mask from 'components/mask/index';
import Dialog from 'components/dialog/index';
import Button from 'components/button/index';
import Header from './header';
import moment from 'moment';
import './main.css';

import {
  closeError,
  getAccountBalance,
  getTranslation,
  getB2BAppSettings,
  changeLanuage
} from './action';

class MainIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleErrorEvent = this.handleErrorEvent.bind(this);
  }

  async componentDidMount() {
    const self = this,
      { props } = self,
      { dispatch = () => { } } = props;
    
    if (sessionStorage.getItem('user')) {
      // 取得帳戶餘額
      await dispatch(getAccountBalance());
    }
    await dispatch(getTranslation());
    await dispatch(getB2BAppSettings());
  }
  UNSAFE_componentWillMount() {
    //main進入時設定預設語系
    const self = this,
      { props } = self,
      { 
        dispatch = () => { }
      } = props;
    let lang = props.location.pathname.split('/')[1] || 'zh-tw'; //預設zh-tw
    // 語系列表
    // const localeList = ['en', 'zh-tw', 'kr', 'jp', 'th'];
    const localeList = ['en', 'zh-tw'];
    // 若不合法語系值則轉為zh-tw
		if (!localeList.includes(lang)) { 
			lang = 'zh-tw';
    }
    
    let data;
    setLocale(lang);
    switch (lang) {
      case 'zh-tw':
        data = {
          label: '中文',
          value: 'zh-tw'
        };
        moment.locale('zh-tw');
        break;
      case 'jp':
        data = {
          label: '日本語',
          value: 'jp'
        };
        moment.locale('ja');
        break;
      case 'kr':
        data = {
          label: '한국어',
          value: 'kr'
        };
        moment.locale('ko');
        break;
      case 'th':
        data = {
          label: 'ไทย',
          value: 'th'
        };
        moment.locale('th');
        break;
      case 'en':
      default:
        data = {
          label: 'English',
          value: 'en'
        };
        moment.locale('en');
        break;
    }
    dispatch(changeLanuage(data, this.props));
  }

  handleErrorEvent() { 
    const self = this,
      {
        props
      } = self,
      {
        state,
      } = props,
      {
        errorRedirect
      } = state;
    
    if (errorRedirect) { 
      let url;
      switch (errorRedirect) { 
        case 'login':
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('agentName');
          url = Tools.generateLocaleUrl(getLocale(), '/Login')
          this.props.history.push(url);
          break;
        default:
          url = Tools.generateLocaleUrl(getLocale(), '/Home')
          this.props.history.push(url);
          break;
      }
    }
    
  }

  render() {
    const self = this,
      {
        props
      } = self,
      {
        state,
        dispatch = () => { }
      } = props,
      {
        loading,
        errorState,
        errorHeader,
        errorMessage
      } = state;
    
    return (
      <Fragment>
        <Header />
        <Mask open={loading} />
        <Dialog
          dialogId='main-error-dialog'
          maxWidth='xs'
          zIndex={2000}
          open={!!errorState}
          onClose={() => {
            dispatch(closeError());
          }}
          title={errorHeader ? errorHeader : i18n('error_message_tryAgain')}
          actionsClassName='main-error-dialog-action'
          actions={[
            <Button
              size='large'
              className='close-button'
              onClick={() => {
                dispatch(closeError())
                  .then(() => { 
                    this.handleErrorEvent()
                })
              }}
            >
              {i18n('close')}
            </Button>
          ]}
        >
          <div className='main-error-dialog-body'>{errorMessage}</div>
        </Dialog>
        <div className='main-container'>
          {props.children}
        </div>
      </Fragment>
    );
  }
};

let mapStateToProps = (state) => {
  return {
    state: state.mainReducer
  };
};

export default connect(mapStateToProps)(withRouter(MainIndex));